import {FormDecorator} from './logic/FormDecorator';
import {BehaviorSubject} from 'rxjs';
import {FormState} from './state/FormState';

export interface FormConfig {
  debug?: boolean;
  preserveValues?: boolean; // If true, copies old form values to new form before destroying the old form (useful when you want to dynamically change the schema while the form is rendered)
  decorators?: FormDecorator[]; // Applied at build time (before first rendering)
  $state?: BehaviorSubject<FormState>;
}

export function defaultFormConfig(): FormConfig {
  return {};
}
